/* SETTINGS */
export const CHANGE_BOTACTIVATION = 'CHANGE_BOTACTIVATION';
export const CHANGE_PROPERTYID = 'CHANGE_PROPERTYID';
export const CHANGE_PROPERTYNAME = 'CHANGE_PROPERTYNAME';
export const CHANGE_DOMAIN = 'CHANGE_DOMAIN';
export const CHANGE_AVATARCLICK = 'CHANGE_AVATARCLICK';
export const CURRENT_GROUPID = 'CURRENT_GROUPID';
export const CURRENT_GROUPNAME = 'CURRENT_GROUPNAME';
export const CHANGE_LEVEL = 'CHANGE_LEVEL';
export const IS_GROUP_BUTTON = 'IS_GROUP_BUTTON';
export const CHANGE_INTEGRATION_CHANNEL = 'CHANGE_INTEGRATION_CHANNEL';
export const CHAT_STARTED = 'CHAT_STARTED';
export const CHANGE_BACK_TO_LIST = 'CHANGE_BACK_TO_LIST';
export const CHANGE_CURRENCY = 'CHANGE_CURRENCY';
export const CHANGE_MODE = 'CHANGE_MODE';
export * from './messenger/actions';
